//@ts-nocheck
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import "@banno/jha-wc/src/icons/jha-icon-delete";
import "@banno/jha-wc/src/icons/jha-icon-edit";
import "@banno/jha-wc/src/icons/jha-icon-close";
import "@banno/jha-wc/src/icons/jha-icon-circle-plus";
import "@banno/jha-wc/src/icons/jha-icon-circle-checkmark-filled";
import "@banno/jha-wc/src/tables/jha-table/jha-table";
import "@banno/jha-wc/src/tables/jha-table-cell/jha-table-cell";
import "@banno/jha-wc/src/tables/jha-table-header/jha-table-header";
import "@banno/jha-wc/src/tables/jha-table-row/jha-table-row";
import "@banno/jha-wc/src/forms/jha-form-select/jha-form-select";
import "@banno/jha-wc/src/forms/jha-form-email-input/jha-form-email-input";
import "@banno/jha-wc/src/buttons/jha-button/jha-button";
import { getRequest } from "../../utils/jha-fetch";
import { Apis } from "../../utils/api-constants";
import { getRoleData } from "../../utils/getRoleData";
import formElementMixin from "@banno/jha-wc/src/js/mixins/form-element-mixin";
import Cookies from "js-cookie";
import { decryptValue, getEnvApiUrl } from "../../utils/app-utils";
@customElement("notification-view")
export class NotificationView extends formElementMixin(LitElement) {
  constructor() {
    super();
    // Initialize dropdown values with fallback data
    this.messageTypeValues = [
      { name: "Success", value: "Success" },
      { name: "Failure", value: "Failure" },
    ];
    this.notificationTypeValues = [{ name: "Email", value: "Email" }];
  }
  static readonly styles = css`
    :host {
      display: block;
      padding: 20px;
    }
    #notDiv {
      display: flex;
      flex-direction: column;
    }
    h2 {
      margin-top: 0;
      margin-bottom: 20px;
      font-size: 24px;
      font-weight: 600;
    }
    .info-text {
      color: var(--jha-text-light);
      font-size: 14px;
      margin-top: 0;
      margin-bottom: 16px;
    }
    .cell-display {
      word-break: break-word;
    }
    jha-table-cell > jha-tooltip {
      display: block;
    }
    .no-notifications-message {
      padding: 32px;
      text-align: center;
      border: 1px solid;
      border-top: none;
    }
    jha-table {
      flex: 1;
      width: 100%;
      box-sizing: border-box;
      border-collapse: collapse;
    }
    jha-table-header {
      font-weight: 600;
      padding: 12px;
      text-align: left;
      white-space: nowrap;
      background: var(--jh-color-container-primary-enabled, rgb(244, 244, 244));
      border-top: 1px solid var(--jh-color-divider-primary);
      vertical-align: middle;
    }
    jha-table-cell {
      padding: 12px;
      vertical-align: middle;
      border-left: 1px solid var(--jha-advanced-table-cell-border);
      font-size: 15px;
      line-height: 1.4;
    }
    jha-table-row {
      border-bottom: 1px solid;
    }
    jha-form-select,
    jha-form-input,
    jha-form-email-input {
      width: 100%;
      min-width: 120px;
      display: block;
    }
    .action-cell {
      text-align: center;
    }
    /* Open row: drop the number and icons below the input labels so they sit level with the boxes. */
    jha-table-cell.editing-cell {
      vertical-align: top;
    }
    .editing-row-content {
      display: inline-block;
      margin-top: 36px;
    }
    .action-icons {
      display: flex;
      gap: 8px;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
    .action-icon {
      cursor: pointer;
      width: 20px;
      height: 20px;
      transition: opacity 0.2s;
    }
    .action-icon:hover {
      opacity: 0.7;
    }
    .action-icon[disabled] {
      cursor: not-allowed;
      opacity: 0.3;
    }
    jha-icon-edit {
      color: var(--jha-color-primary, #0066cc);
    }
    jha-icon-delete {
      color: var(--jha-color-danger, #dc3545);
    }
    jha-icon-close {
      color: var(--jha-color-secondary, #6c757d);
    }
    jha-icon-circle-checkmark-filled {
      color: var(--jha-color-success, #28a745);
    }
    @media (prefers-color-scheme: light) {
      h2 {
        color: #06185f;
      }
      .no-notifications-message {
        color: #666666;
        border-color: #e0e0e0;
      }
      jha-table-row {
        border-bottom-color: #e0e0e0;
      }
    }
    @media (prefers-color-scheme: dark) {
      h2 {
        color: #a3d4ff;
      }
      .no-notifications-message {
        color: #a0a0a0;
        border-color: #3a3a3a;
      }
      jha-table {
        border: 1px solid #3a3a3a;
      }
      jha-table-row {
        border-bottom-color: #3a3a3a;
      }
      jha-icon-edit {
        color: #4da6ff;
      }
      jha-icon-delete {
        color: #ff6b6b;
      }
      jha-icon-close {
        color: #999999;
    }
    }
    #btnDiv {
      display: flex;
      margin-top: 16px;
      justify-content: flex-end;
    }
  `;
  @property({ type: Array })
  notificationList = [];
  @property()
  toUpdate: "update";
  @property({ type: Object })
  usersData = [
    {
      number: 1,
      messageType: "",
      notificationType: "",
      to: "",
      subject: "",
      template: "",
    },
  ];

  @property({ type: Object })
  formData = {
    number: 1,
    messageType: "",
    notificationType: "",
    to: "",
    subject: "",
    template: "",
    added: false,
  };
  @property({ type: Object })
  resetformData = {
    number: 1,
    messageType: "",
    notificationType: "",
    to: "",
    subject: "",
    template: "",
    added: false,
  };
  @property({ type: Array })
  messageTypeValues = [
    { name: "Success", value: "Success" },
    { name: "Failure", value: "Failure" },
  ];
  @property({ type: Array })
  notificationTypeValues = [{ name: "Email", value: "Email" }];
  @property({ type: Boolean })
  isReadOnlyUser = /readonly/i.test(decryptValue(Cookies.get("userRole")))
  @property({ type: Boolean })
  isNotSavedNot = false;
  optionLabel(options, stored) {
    const key = String(stored ?? "").toLowerCase();
    const match = (options ?? []).find((option) => String(option?.value ?? "").toLowerCase() === key);
    return match?.name || stored;
  }
  onAddNotClick() {
    let a = [...this.notificationList];
    a.push({
      number: a.length + 1,
      messageType: "",
      notificationType: "",
      to: "",
      subject: "",
      template: "",
      added: false,
    });
    this.notificationList = a;
    // checkformValid points formData at the last loaded row; a new row must not inherit it.
    this.formData = { ...this.resetformData };
    this.isNotSavedNot = true;
  }
  editIndex = -1;
  editSnapshot = null;
  onSaveNotClick() {
    if (!this.formDirty) return;
    // Blur only keeps the open row's draft. The checkmark is what locks it into the grid.
    const editing = this.editIndex >= 0;
    const index = editing ? this.editIndex : this.notificationList.length - 1;
    if (index < 0) return;
    this.formData.number = index + 1;
    this.formData.added = false;
    this.notificationList[index] = JSON.parse(JSON.stringify(this.formData));
    this.toUpdate = this.toUpdate == "" ? "update" : "";
    this.dispatchEvent(new CustomEvent("onformNotValid", { detail: this.formData, bubbles: true, composed: true }));
  }
  onDeleteNotClick(item) {
    const deleteIndex = this.notificationList.indexOf(item);
    if (deleteIndex < this.editIndex) this.editIndex--;
    this.notificationList.splice(deleteIndex, 1);
    this.notificationList.forEach((element: any, index: number) => {
      element.number = index + 1;
    });
    this.toUpdate = this.toUpdate == "" ? "update" : "";
  }
  onEditNotClick(item) {
    if (this.isReadOnlyUser || this.isNotSavedNot) return;
    this.editIndex = this.notificationList.indexOf(item);
    this.editSnapshot = JSON.parse(JSON.stringify(item));
    item.added = false;
    this.formData = { ...item };
    this.isNotSavedNot = true;
    this.toUpdate = this.toUpdate == "" ? "update" : "";
  }
  onCommitNotClick() {
    if (!this.formValid) return;
    const index = this.editIndex >= 0 ? this.editIndex : this.notificationList.length - 1;
    if (index < 0) return;
    this.notificationList[index] = { ...JSON.parse(JSON.stringify(this.formData)), number: index + 1, added: true };
    this.endNotEdit();
  }
  onCancelNotClick() {
    if (this.editIndex >= 0) {
      this.notificationList[this.editIndex] = this.editSnapshot;
    } else {
      this.notificationList.pop();
    }
    this.endNotEdit();
  }
  endNotEdit() {
    this.editIndex = -1;
    this.editSnapshot = null;
    this.formData = this.resetformData;
    this.isNotSavedNot = false;
    this.toUpdate = this.toUpdate == "" ? "update" : "";
    this.dispatchEvent(new CustomEvent("onformNotValid", { detail: this.formData, bubbles: true, composed: true }));
  }
  async connectedCallback() {
    super.connectedCallback();
    try {
      // getEnvApiUrl: localhost-only; .env.local never ships — no effect in prod, test, staging, or CI builds.
      const notTypeRes = await getRequest(getEnvApiUrl(Apis.NOTIFICATION_TYPE));
      const notMsgType = await getRequest(getEnvApiUrl(Apis.NOTIFICATION_MESSAGE_TYPE));

      // Check if we got valid data from the API
      const notificationTypes = getRoleData(notTypeRes?.list ?? []);
      const messageTypes = getRoleData(notMsgType?.list ?? []);

      // If we got empty arrays (due to auth errors or other issues), keep fallback values (already set as defaults)
      if (notificationTypes.length > 0 && messageTypes.length > 0) {
        // Only update if we got valid data from API
        this.notificationTypeValues = notificationTypes;
        this.messageTypeValues = messageTypes;
        this.requestUpdate();
      }
    } catch (error) {
      // Fallback values are already set as property defaults
      console.error("Failed to load notification options:", error);
    }
    await this.checkformValid();
  }
  async disconnectedCallback(): void {
    super.disconnectedCallback();
  }
  async checkformValid() {
    if (this.notificationList.length > 0) {
      this.formData = this.notificationList[this.notificationList.length - 1];
      if (!this.formValid) {
        this.isNotSavedNot = true;
      }
    }
  }
  render() {
    this.dispatchEvent(
      new CustomEvent("onNotificationChange", {
        detail: this.notificationList,
        bubbles: true,
        composed: true,
      })

    );
    return html`
      <div id="notDiv">
        <h2>Notification Configuration</h2>
        <p class="info-text">Configure email notifications to be sent when this workflow succeeds or fails. Notifications are optional.</p>
        <jha-table data=${this.notificationList}>
          <jha-table-row>
            <jha-table-header style="width: 60px;">NO.</jha-table-header>
            <jha-table-header style="width: 140px;">MESSAGE TYPE</jha-table-header>
            <jha-table-header style="width: 160px;">NOTIFICATION TYPE</jha-table-header>
            <jha-table-header style="min-width: 200px;">TO</jha-table-header>
            <jha-table-header style="min-width: 180px;">SUBJECT</jha-table-header>
            <jha-table-header style="min-width: 200px;">TEMPLATE MESSAGE</jha-table-header>
            <jha-table-header style="width: 80px; text-align: center;">ACTIONS</jha-table-header>
          </jha-table-row>
          ${this.notificationList?.map(
      (item) => html`
              <jha-table-row>
                <form style="display:contents;">
                  <jha-table-cell class=${item.added == true ? '' : 'editing-cell'}><span class=${item.added == true ? '' : 'editing-row-content'}>${item.number}</span></jha-table-cell>
                  <jha-table-cell
                    >
                  ${item.added == true ? html`<span class="cell-display">${this.optionLabel(this.messageTypeValues, item.messageType)}</span>` : html`
                  <jha-tooltip bottom text="Select message type to send notification when workflow succeeds or fails.">
                  <jha-form-select
                      text-align="center"
                      data-auto-id="notificationMessageTypeSelect"
                      outline
                      required
                      warning="Message Type is Required"
                      .options=${this.messageTypeValues ?? []}
                      data-id="messageType"
                      @change=${this.inputValueChange}
                      @blur=${this.onSaveNotClick}
                      label="Message Type"
                      labelKey="name"
                      valueKey="value"
                      ?disabled=${item.added == true}
                      isValid
                      emptyOptionLabel="Select Message Type"
                      .value=${item.messageType}
                    ></jha-form-select
                  >
                  </jha-tooltip>`}
                    </jha-table-cell>
                  <jha-table-cell
                    >
                  ${item.added == true ? html`<span class="cell-display">${this.optionLabel(this.notificationTypeValues, item.notificationType)}</span>` : html`
                  <jha-tooltip bottom text="Select type of notification to send.">
                    <jha-form-select
                      data-auto-id="notificationTypeSelect"
                      outline
                      required
                      warning="Notification Type is Required"
                      label="Notification Type"
                      .options=${this.notificationTypeValues ?? []}
                      data-id="notificationType"
                      @change=${this.inputValueChange}
                      @blur=${this.onSaveNotClick}
                      .value=${item.notificationType}
                      labelKey="name"
                      valueKey="value"
                      ?disabled=${item.added == true}
                      isValid
                      emptyOptionLabel="Select Notification Type"
                    ></jha-form-select
                  >
                  </jha-tooltip>`}
                    </jha-table-cell>
                  <jha-table-cell
                    >
                  ${item.added == true ? html`<span class="cell-display">${item.to}</span>` : html`
                  <jha-tooltip bottom text="Enter valid Email Address to receive notification.">
                    <jha-form-email-input
                      data-auto-id="notificationEmailInput"
                      required
                      warning="Email (To) is Required"
                      type="email"
                      role="textbox"
                      outline
                      data-id="to"
                      placeholder="Eg: name@domain.com"
                      label="Email (To)"
                      ?disabled=${item.added == true}
                      @change=${this.inputValueChange}
                      @blur=${this.onSaveNotClick}
                      .value=${item.to}
                      maxlength="256"
                    ></jha-form-email-input
                  >
                  </jha-tooltip>`}
                  </jha-table-cell>
                  <jha-table-cell
                    >
                  ${item.added == true ? html`<span class="cell-display">${item.subject}</span>` : html`
                  <jha-tooltip bottom text="Enter information to display in subject of notification.  Allowed characters . _ - , ; @ ( )">
                    <jha-form-input
                      data-auto-id="notificationSubjectInput"
                      required
                      warning="Subject is Required"
                      type="text"
                      outline
                      data-id="subject"
                      placeholder="Enter Notification Subject"
                      label="Subject"
                      ?disabled=${item.added == true}
                      @change=${this.inputValueChange}
                      @blur=${this.onSaveNotClick}
                      maxlength="255"
                      .value=${item.subject}
                      pattern="^[A-Za-z0-9._\\-\\s\\,\\;\\@\\(\\)]+$"
                    ></jha-form-input
                  >
                  </jha-tooltip>`}
                  </jha-table-cell>
                  <jha-table-cell
                    >
                  ${item.added == true ? html`<span class="cell-display">${item.template}</span>` : html`
                  <jha-tooltip bottom text="Enter information to display in body of notification.  Allowed characters . _ - , ; @ ( )">
                    <jha-form-input
                      data-auto-id="notificationTemplateInput"
                      required
                      warning="Template Message is Required"
                      type="text"
                      placeholder="Enter Template Information"
                      outline
                      label="Template Message"
                      data-id="template"
                      @change=${this.inputValueChange}
                      @blur=${this.onSaveNotClick}
                      ?disabled=${item.added == true}
                      .value=${item.template}
                      maxlength="255"
                      pattern="^[A-Za-z0-9._\\-\\s\\,\\;\\@\\(\\)]+$"
                    ></jha-form-input
                  >
                  </jha-tooltip>`}
                  </jha-table-cell>
                  <jha-table-cell class="action-cell ${item.added == true ? '' : 'editing-cell'}">
                  <div class="action-icons ${item.added == true ? '' : 'editing-row-content'}">
                  ${item.added == true
          ? html`<jha-tooltip left text="Edit Notification">
                          <jha-icon-edit class="action-icon" data-auto-id="editNotificationBtn" ?disabled=${this.isReadOnlyUser} @click=${this.isReadOnlyUser ? null : () => this.onEditNotClick(item)}></jha-icon-edit>
                          </jha-tooltip>
                        <jha-tooltip left text="Delete Notification">
                          <jha-icon-delete class="action-icon" data-auto-id="deleteNotificationBtn" ?disabled=${this.isReadOnlyUser} @click=${this.isReadOnlyUser ? null : () => this.onDeleteNotClick(item)}></jha-icon-delete>
                        </jha-tooltip>`
          : html`<jha-tooltip left text="Save Notification">
                          <jha-icon-circle-checkmark-filled class="action-icon" data-auto-id="saveNotificationBtn" ?disabled=${this.isReadOnlyUser} @click=${this.isReadOnlyUser ? null : this.onCommitNotClick}></jha-icon-circle-checkmark-filled>
                          </jha-tooltip>
                        <jha-tooltip left text="Cancel">
                          <jha-icon-close class="action-icon" data-auto-id="cancelNotificationBtn" ?disabled=${this.isReadOnlyUser} @click=${this.isReadOnlyUser ? null : this.onCancelNotClick}></jha-icon-close>
                        </jha-tooltip>`}
                  </div>
                  </jha-table-cell>
                </form>
              </jha-table-row>
            `
    )}
        </jha-table>
        ${this.notificationList?.length ? '' : html`<div class="no-notifications-message"><h3>No Notifications Found</h3></div>`}
        <div id="btnDiv">
        <jha-tooltip left text="Click to Add Notification">
          <jha-button data-auto-id="addNotificationBtn" type="button" primary sync @click=${this.onAddNotClick} ?disabled=${this.isReadOnlyUser || this.isNotSavedNot}
            ><jha-icon-plus slot="icon-left"></jha-icon-plus>Add
            Notification</jha-button
          >
          </jha-tooltip>
        </div>
      </div>
    `;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    "notification-view": NotificationView;
  }
}
